// extracted by mini-css-extract-plugin
export default {"heading":"styles__heading___hUk0M","display":"styles__display___gTvbx"};